<template>
  <b-card no-body>
    <b-card-body class="text-right">
      <b-button
        variant="primary"
        @click="removeData"
      >
        <FeatherIcon icon="TrashIcon" /> Tümünü Temizle
      </b-button>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      hover
    >
      <template #cell(title)="data">
        <div class="d-flex align-items-center">
          <div class="mr-2">
            <b-button
              variant="danger"
              size="sm"
              pill
              @click="removeData(data.item.params)"
            >
              <FeatherIcon icon="TrashIcon" /> Temizle
            </b-button>
          </div>
          <div class="font-weight-bold">
            {{ data.item.title }}
          </div>
        </div>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BButton, BCard, BCardBody, BTable,
} from 'bootstrap-vue'

export default {
  name: 'CacheParams',
  components: {
    BCard,
    BCardBody,
    BTable,
    BButton,
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'BÖLÜM',
        },
        {
          key: 'fileSize',
          label: 'Önbellek Boyutu',
          thClass: 'width-200',
        },
      ],
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['cacheParams/dataList']
    },
    saveData() {
      return this.$store.getters['cacheParams/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('cacheParams/getDataList')
    },
    removeData(file = null) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('cacheParams/removeCache', { file })
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
